import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=72f9067b&scoped=true&"
import script from "./Share.vue?vue&type=script&lang=ts&"
export * from "./Share.vue?vue&type=script&lang=ts&"
import style0 from "./Share.vue?vue&type=style&index=0&id=72f9067b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9067b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardActions,VCardText,VDialog,VIcon})
